import galleryHtml from './gallery.component.html';
import './gallery.component.scss';

class GalleryController {
    constructor($scope, $timeout, $window, $sce) {
        'ngInject';

        this.$scope = $scope;
        this.$timeout = $timeout;
        this.$window = $window;
        this.$sce = $sce;
        this.limit = 5;
        this.showFull = false;
        this.supportsMatchMedia = this.$window.matchMedia !== undefined && !!this.$window.matchMedia('all').addListener;
        this.handleKeyboardEvent = ($event) => {
            this.handleKeyboard($event);
            this.$scope.$apply();
        };
        this.thumbnailsRange ={
            from: 0,
            to: 4
        }
        this.zoomEnabled = false;
        this.youtube = false;
        this.images = [];
    }

    get thumbnails() {
        return this.images.slice(this.thumbnailsRange.from, this.thumbnailsRange.to).map(url => {
            let ytCheck = this.checkYoutubeHash(url);

            if (ytCheck) {
                return 'https://img.youtube.com/vi/' + ytCheck + '/0.jpg';
            }

            return url;
        });
    }

    get preparedImages() {
        return this.images.map(url => {
            let ytCheck = this.checkYoutubeHash(url);

            if (ytCheck) {
                return 'https://img.youtube.com/vi/' + ytCheck + '/0.jpg';
            }

            return url;
        });
    }

    get index() {
        return this.images.indexOf(this.current);
    }

    $onInit() {
        this.$timeout(() => {
            this.limit = Number.MAX_SAFE_INTEGER;
        }, 5000);

        this.$scope.clickOutside = () => {
            if (!this.showFull) return;

            this.showFull = false;
            this.$scope.$apply();
        };

        angular.element(this.$window).bind('keydown', this.handleKeyboardEvent);
    }

    $onDestroy() {
        angular.element(this.$window).unbind('keydown', this.handleKeyboardEvent);
    }

    $onChanges(changesObj) {

        let duplicateFiles = [];

        // Remove duplicate files
        const currentFileId = this.imagesList.find(image => image.url === this.current).file_id;

        this.images = this.imagesList.filter(image => {
            if (!duplicateFiles[image.file_id] && currentFileId !== image.file_id) {
                duplicateFiles[image.file_id] = true;
                return true;
            }
            if (this.current == image.url) {
                return true;
            }
        }).map(image => image.url);

        const index = this.index;

        if (index > this.thumbnailsRange.from && index < this.thumbnailsRange.to - 1) return;

        const group = Math.floor(index / 4);
        const offset = index % 4;
        let additionalOffset = 0;

        if (offset == 0) additionalOffset--;
        if (offset == 3) additionalOffset++;

        const from = group * 4 + additionalOffset;
        const to = from + 4;

        if (to > this.images.length) {
            this.thumbnailsRange = {
                from: this.images.length - 4,
                to: this.images.length
            }

            return;
        }

        if (from < 0) {
            this.thumbnailsRange = {
                from: 0,
                to: 4
            }

            return;
        }

        this.thumbnailsRange = { from, to };
    }

    handleKeyboard($event) {
        if (!this.showFull) return;

        $event.stopPropagation();
        $event.preventDefault();

        switch ($event.which) {
            case 27:
                this.closeFull();
                break;
            case 37:
                this.prev();
                break;
            case 39:
                this.next();
                break;
        }
    }

    closeFull($event = null) {
        if ($event) $event.stopPropagation();
        this.showFull = false;
    }

    openFull($event = null) {
        if (this.supportsMatchMedia && this.$window.matchMedia("(max-width: 600px)").matches) {
            return;
        }

        if ($event) $event.stopPropagation();

        this.showFull = true;
    }

    setCurrent(url, $event = null) {
        if ($event) $event.stopPropagation();

        this.youtube = this.checkYoutubeHash(url);

        this.current = url;

        if (!this.change || typeof this.change != 'function') return;

        this.change({imageUrl: url});
    }

    next($event = null) {
        if ($event && $event.stopPropagation) $event.stopPropagation();
        const index = this.index;

        if (index + 1 >= this.images.length) {
            this.setCurrent(this.images[0]);
        } else {
            this.setCurrent(this.images[index + 1]);
        }
    }

    prev($event = null) {
        if ($event && $event.stopPropagation) $event.stopPropagation();
        const index = this.index;

        if (index <= 0) {
            this.setCurrent(this.images[this.images.length - 1]);
        } else {
            this.setCurrent(this.images[index - 1]);
        }
    }

    enableZoom($event) {
        this.zoomEnabled = true;
    }

    disableZoom($event) {
        this.zoomEnabled = false;
    }

    toggleZoom($event) {
        this.zoomEnabled = !this.zoomEnabled;
    }

    checkYoutubeHash(url) {
        var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#\&\?]*).*/;
        var match = url.match(regExp);

        if (match && match[7].length == 11){
            return match[7];
        }

        var imageCheck = /img.youtube.com\/vi\/(.*?)\//;
        var match = url.match(imageCheck);

        if (match && match[1].length == 11){
            return match[1];
        }

        return false;
    }

    trustedUrl(url) {
        return this.$sce.trustAsResourceUrl(url);
    }
}

let galleryComponent = {
    bindings: {
        imagesList: '<',
        current: '<',
        change: '&'
    },
    template: galleryHtml,
    controller: GalleryController
}

export default galleryComponent;